<template>
  <div class="fast-footer-widget tw-space-y-4">
    <!-- Footer Title -->
    <h2
      class="fast-footer-title tw-mb-4 tw-text-mb-title-5 lg:tw-text-dt-title-5"
    >
      {{ $t('global.menu') }}
    </h2>

    <!-- Footer Menu List -->
    <ul class="tw-grid tw-grid-cols-2 tw-gap-x-14 tw-gap-y-3 lg:tw-inline-grid lg:tw-w-fit lg:tw-grid-cols-[max-content_max-content] lg:tw-justify-start lg:tw-justify-items-start">
      <li
        v-for="(menu) in footerMenus"
        :key="`menu-${menu._id}`"
        class="tw-w-max tw-justify-self-start tw-text-mb-body-small lg:tw-text-dt-body-small"
      >
        <LinkLocale
          :to="`/${menu.slug}`"
          :title="menu.title"
          class="link-underline-hover"
          @click="eventFooterlink(menu.title)"
        >
          {{ menu.title }}
        </LinkLocale>
      </li>

      <!-- PDPA Link -->
      <li
        v-if="pdpa.show && showcookie"
        :key="'menu-pdpa'"
        class="tw-w-max tw-justify-self-start tw-text-mb-body-small lg:tw-text-dt-body-small"
      >
        <LinkLocale
          :to="'/privacy-policy'"
          :title="pdpa.title"
          class="link-underline-hover"
          @click="eventFooterlink(pdpa.title)"
        >
          {{ pdpa.title }}
        </LinkLocale>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const { footerMenus, eventFooterlink, showcookie, pdpa } = useFooterLink()
</script>
